import { apiCallPost } from "../api"
import { apiPaths } from "../config/apiPaths";

export const getListApi = async (path,filtersArray,offset,authHeaders) => {
    const inputData = {
        path: path,
        filters: filtersArray,
        offset,
    }
    try {
        const res = await apiCallPost(apiPaths.getList, inputData, authHeaders);
        if (res.data) {
            let listData = res.data ?? {};
            return { data: listData, status: true }
        }
        return { data: [], status: false, errMsg: 'Some Error Occurred' };
    } catch (err) {
        return { status: false, errMsg: err.message }
    }
}